<template lang="pug">
v-container
  v-row
    v-col
      h1 Корзина
    v-col(cols="12")
      v-card(outlined).pt-2
        smart-table(
          :headers="headers"
          :adapter="adapter"
          hide-search-actions
          hide-expand
        )
          template(#value--updated_at="{ item }") {{ item.updated_at | readableDate }}
          template(#value--view="{ item }")
            router-link(:to="`/application/${item.id}`" target="_blank")
              v-icon(color="primary" small) mdi-eye

</template>

<script>
import SmartTable from '@/components/SmartTable/index.vue';
import clientQuestionsService from '@/services/API/client-questions';
import { CLIENT_QUESTION_STATUS } from '../constants';
import mixinDateTime from '@/mixins/mixinDateTime';

export default {
  components: {
    SmartTable,
  },
  mixins:[mixinDateTime],
  data() {
    return {
      search: '',
      headers: [
        {
          text: '',
          value: 'view',
        },
        {
          text: 'Номер',
          value: 'id',
          sortable:true,
          searchable: true,
        },
        {
          text: 'Дата удаления',
          value: 'updated_at',
          sortable: true,
        },
        {
          text: 'Почта отправителя',
          sortable:true,
          value: 'email',
          searchable:true,
        },
        // { text: 'Роль пользователя', value: 'role',          sortable:true },
        // { text: 'Регион', value: 'region',          sortable:true },
        // { text: 'Тип проблемы', value: 'type_problem',          sortable:true },
      ],
    };
  },
  methods:{
    adapter(options) {
      const params = {
        'sort':'-id',
        ...options,
        'search[status]':CLIENT_QUESTION_STATUS.DELETED,
      };

      this.needToUpdateTable = false;

      return clientQuestionsService.getAll(params);
    },
  },
};
</script>

<style lang="scss">
.theme--light .v-data-table-header th {
  min-width: auto;
}
.v-dialog.v-dialog--active {
  overflow-y: visible;
}
.close {
  position: absolute;
  right: -20px;
  top: -15px;
}
</style>
